import './rates-info.scss';

import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import {
	DailyRatesChart,
	type ViewMode,
} from '@/features/rules/rates/components/daily-rates-chart';
import { useState } from 'react';

export const RatesInfo = () => {
	const [viewMode, setViewMode] = useState<ViewMode>('daily');

	const handleSwitchChange = (checked: boolean) => {
		setViewMode(checked ? 'daily' : 'average');
	};

	return (
		<div className='rates-info'>
			<div className='info'>
				<div>
					<h3 className='header'>Rate Boundary</h3>
					<p className='text'>
						Minimum and maximum rate boundaries for rate recommendation for the
						season
					</p>
				</div>
				<div>
					<h3 className='header'>Derived Rate</h3>
					<p className='text'>
						Increment/decrement currency value for the secondary room type
					</p>
				</div>
				<div>
					<div className='tw-flex tw-items-center tw-space-x-2 tw-mb-2'>
						<Switch
							id='view-mode'
							checked={viewMode === 'daily'}
							onCheckedChange={handleSwitchChange}
						/>
						<Label htmlFor='view-mode'>
							{viewMode === 'daily' ? 'Daily' : 'Average DOW'}
						</Label>
					</div>
					<DailyRatesChart viewMode={viewMode} />
				</div>
			</div>
		</div>
	);
};
